<template>
    <footer>
        <div>
            <p>© 2025-{{ currentYear }} Powered by Tinovo Technology Services.</p>
        </div>
    </footer>
</template>

<script>
export default {
    computed: {
        currentYear() {
            return new Date().getFullYear();
        }
    },
}
</script>
